import React from "react";

const spinnerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  minHeight: 80,
  fontSize: 22,
  color: "#2563eb",
  fontWeight: 500,
};

function LoadingSpinner({ text = "Loading..." }) {
  return (
    <div style={spinnerStyle}>
      <span role="img" aria-label="loading" style={{ marginRight: 10 }}>
        ⏳
      </span>
      {text}
    </div>
  );
}

export default LoadingSpinner;
